import { useId } from "react";
import { t } from "../../i18n/t";

export const MIN_PASSWORD_LENGTH = 10;

/** Client-side check matching the API (≥ 10 characters); returns a Norwegian error or null. */
export function passwordProblem(password: string, confirm: string): string | null {
  if (password.length < MIN_PASSWORD_LENGTH) return t("auth.passwordTooShort");
  if (password !== confirm) return t("auth.passwordMismatch");
  return null;
}

export function PasswordFields({
  password,
  confirm,
  onPassword,
  onConfirm,
}: {
  password: string;
  confirm: string;
  onPassword: (v: string) => void;
  onConfirm: (v: string) => void;
}) {
  const id = useId();
  return (
    <>
      <div className="field">
        <label htmlFor={`${id}-pw`}>{t("auth.newPassword")}</label>
        <input
          id={`${id}-pw`}
          type="password"
          autoComplete="new-password"
          required
          minLength={MIN_PASSWORD_LENGTH}
          maxLength={256}
          aria-describedby={`${id}-hint`}
          value={password}
          onChange={(e) => onPassword(e.target.value)}
        />
        <span id={`${id}-hint`} className="hint">
          {t("auth.passwordHint")}
        </span>
      </div>
      <div className="field">
        <label htmlFor={`${id}-confirm`}>{t("auth.confirmPassword")}</label>
        <input
          id={`${id}-confirm`}
          type="password"
          autoComplete="new-password"
          required
          maxLength={256}
          value={confirm}
          onChange={(e) => onConfirm(e.target.value)}
        />
      </div>
    </>
  );
}
